import React from 'react';
import { useSelector } from 'react-redux';
import LeagueStatsHeader from '../components/reusable/LeagueStatsHeader';

const LeagueTopScorer = () => {
    const { selectedLeagueData } = useSelector(
        ({ leagues: { selectedLeagueData } }) => ({
            selectedLeagueData
        })
    );

    return (
        <div>
            <LeagueStatsHeader from={'/league-and-stats'} />
            <div className='px-[15px] mt-[25px]'>
                <p className='uppercase text-[16px] font-favela-bold font-bold'>
                    toP SCORER
                </p>

                <table className='w-full'>
                    <tbody>
                        {selectedLeagueData?.leagueStats?.topScorers
                            ?.sort(
                                (a, b) =>
                                    parseFloat(+b.goals) - parseFloat(+a.goals)
                            )
                            ?.map((data, i) => (
                                <tr
                                    key={i}
                                    className='border-b-[1px] border-[#0000001A]'
                                >
                                    <td className='py-[10px]'>{i + 1}</td>
                                    <td className='py-[10px]'>{data?.name}</td>
                                    <td className='py-[10px] float-right'>
                                        {data.goals}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LeagueTopScorer;
